export default __webpack_public_path__ + "static/media/deucesTableLnd.50f8ec42.webp";